<template>
    <div class="col-lg-6 col-md-6 col-12 " id="import_report_step">
        <div class="card" v-if="userStore.userDashboard.ThreeinOneStatus">
            <div class="collapse-margin collapse-icon" id="personal-info-collapser">
            <div class="card-header" id="paymentOne" data-toggle="collapse" role="button" data-target="#personal-info-collapse" aria-expanded="true"
                aria-controls="personal-info-collapse" >
                <div class="justify-content-between lead collapse-title">
                    <div class="media">
                        <div class="media-body" >
                            <div class="row mx-auto">
                                <div v-if="userStore.userDashboard.ThreeinOneStatus.title == 'Complete'">
                                    <h3 class="mb-1 font-small-4 text-primary">
                                        Update Your Credit Report Info.
                                    </h3>
                                </div>
                                <div v-else>
                                    <p>
                                        <span class="badge badge-primary badge-glow mr-1">Step 2: </span>
                                        <span class="mb-1 font-small-4 text-primary">Enter Your Credit Report Info.</span>
                                    </p>
                                </div>
                            </div>
                            <div class="design-group">
                                <h6 class="section-label">Import Your Credit Report:</h6>
                                <!-- <div
                                    class="badge badge-glow badge-sm mr-0 mb-0" :class="userStore.userDashboard.ThreeinOneStatus.class">
                                    {{userStore.userDashboard.ThreeinOneStatus.title }} <i :data-feather="userStore.userDashboard.ThreeinOneStatus.icon"></i>
                                </div> -->
                                <div v-if="userStore.userDashboard.IQ">
                                    <div class="badge badge-glow badge-sm mr-0 mb-0 badge-success" v-if="userStore.userDashboard.IQ.pull_status == '1'">
                                        Complete
                                        <vue-feather type="check-circle"></vue-feather>
                                    </div>
                                    <div class="badge badge-glow badge-sm mr-0 mb-0 badge-warning" v-else>
                                        Incomplete
                                        <vue-feather type="x-circle"></vue-feather>
                                    </div>
                                </div>
                                <div class="badge badge-glow badge-sm mr-0 mb-0 badge-warning" v-else>
                                    Incomplete <vue-feather type="x-circle"></vue-feather>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="personal-info-collapse" class="collapse show" aria-labelledby="paymentOne" data-parent="#personal-info-collapser">
                <hr>
                <div class="card-body">

                    <div v-if="userStore.userDashboard.IQ">
                        <div v-if="userStore.userDashboard.IQ.pull_status_string == 'Success'">
                            <div class="col-11">
                                <h5 class="text-primary">Congratulations
                                    <span v-if="userStore.userDashboard.user != null"> {{ userStore.userDashboard.user.firstname }}</span>
                                    <span v-else>Creditfixrr</span>
                                , You've imported your Credit Report! 🎉</h5>
                                <p class="card-text font-small-4">
                                    Now that you've imported your <strong>Credit Report</strong>. Creditfixrr's Ai has created your <strong>Credit Analysis Report.</strong>

                                    You can now head to the <strong>Dispute Center</strong> to begin your dispute process.
                                </p>
                                <hr>
                            </div>
                        </div>
                        <div v-else>
                            <p class="card-text font-small-4">
                                Your Next Step is to Import your <strong>Credit Report</strong>. <br /> <br>
                                Once you’ve successfully imported your Credit Report, Creditfixrr’s Ai will generate your Credit Analysis Report for your to Review.<br>
                            </p>
                            <hr>
                        </div>
                    </div>

                    <div v-else>
                        <p class="card-text font-small-4">
                            Your Next Step is to Import your <strong>Credit Report</strong>. <br /> <br>
                            Once you’ve successfully imported your Credit Report, Creditfixrr’s Ai will generate your Credit Analysis Report for your to Review.<br>
                        </p>
                        <hr>
                    </div>

                    <div class="d-flex justify-content-center">
                        <a href="#" class="btn btn-sm btn-primary mr-1 waves-effect waves-light d-flex" data-toggle="modal" data-target="#identity_iq_modal_update">
                            <div v-if="userStore.userDashboard.ThreeinOneStatus.title == 'Complete'" class="d-flex">
                                <vue-feather type="edit" size="18"></vue-feather>
                                <span style="
                                    margin-top: 4px;
                                    padding-left: 5px;
                                "> Update </span>
                            </div>
                            <div class="d-flex" v-else>
                                <vue-feather type="edit" size="18"></vue-feather>
                                <span style="
                                    margin-top: 4px;
                                    padding-left: 5px;
                                "> Import Credit Report</span>
                            </div>
                        </a>
                        <span v-if="userStore.userDashboard.IQ">
                            <a href="#" data-toggle="modal" data-target="#credit_analysis_modal_update" class=" mr-1 btn btn-sm btn-outline-primary waves-effect" v-if="userStore.userDashboard.IQ.pull_status_string == 'Success'">
                                <span><i data-feather="activity"></i></span> Credit Analysis
                            </a>
                        </span>
                        <a href="#" data-toggle="modal" data-target="#dispute_process_modal_video" class="btn btn-sm btn-outline-primary waves-effect d-flex">
                            <vue-feather type="film" size="18"></vue-feather>
                            <span style="
                                margin-top: 4px;
                                padding-left: 5px;
                            "> Tutorial</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {ref} from 'vue'
import { useUserStore } from '../../../stores/UserStore.js'
export default{
    setup(){
        return {
            userStore:useUserStore()
        }
    },
    methods:{
    }
}
</script>
